import React, { useCallback, useEffect, useRef, useState } from "react";
import PageTableHeader from "../../../../components/pageTableHeader/pageTableHeader";
import { useDispatch, useSelector } from "react-redux";
import PaginationComponent from "../../../../components/table/tablePagination";
import AttendanceReportTable from "./components/table";
import toast from "react-hot-toast";
import { FiFilter } from "react-icons/fi";
import DefaultButton from "../../../../components/buttons/defaultButton";
import { getSessionList } from "../../../../../services/workspace/session.service";
import { DefaultSelectFilter } from "../../../../components/inputs/defaultSelectFilter";
import { useLocation } from "react-router-dom";
import {
  academicReport,
  staffAttendanceReport,
  staffAttendanceReportExport,
  studentAttendanceReport,
  studentAttendanceReportExport,
} from "../../../../../services/workspace/report.service";
import YearMonthFilter from "../../../../components/filter/yearMonthFilter";
import moment from "moment";
import { convertToLabelValue } from "../../../../../utils/common";
// Note: _fetchClasses import removed as class functionality is not available for HR management system
import DefaultSearchSelectInput from "../../../../components/inputs/defaultSearchSelectInput";
import { PiExport } from "react-icons/pi";

const AttendanceReports = () => {
  const isFirstRender = useRef(true);
  const location = useLocation();
  const { limit } = useSelector((state) => state.global);
  const [search, setSearch] = useState("");
  const [totalData, setTotalData] = useState(0);
  const [loading, setLoading] = useState(true);
  const [tableData, setTableData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [selectClass, setSelectClass] = useState([]);
  const [selectSection, setSelectSection] = useState([]);
  const [sectionDataList, setSectionDataList] = useState([]);
  const [pageFor, setPageFor] = useState("");
  const dispatch = useDispatch();
  // Note: classes removed as class functionality is not available for HR management system

  const pageType = location.pathname.includes("/staff") ? "staff" : "student";
  const items = [
    { label: "Home", path: "/" },
    { label: "Reports", path: "/reports" },
    {
      label:
        pageType === "staff"
          ? `Staff Attendance Reports`
          : `Students Attendance Reports`,
    },
  ];

  const [selectedDate, setSelectedDate] = useState(new Date());

  const handleChangeDate = (date) => {
    const check = moment(selectedDate).isSame(moment(date), "day");
    if (check) return;
    setSelectedDate(date);
  };

  useEffect(() => {
    setPageFor(pageType);
    
  }, [pageType]);

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
    setCurrentPage(1);
  };

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prev) => !prev);
  };
  const fetchTimeoutRef = useRef(null);

  const fetchData = useCallback(
    () => {
      
      clearTimeout(fetchTimeoutRef.current);
       fetchTimeoutRef.current = setTimeout(() => {
        if(!pageFor){return}
        setLoading(true);
          
        const fetchFunction =
        pageFor === "staff" ? staffAttendanceReport : studentAttendanceReport;

        fetchFunction(
          pageFor === "staff"
            ? {
                date: selectedDate || "",
                page: currentPage,
                limit,
                search,
              }
            : {
                class_id: selectClass?.id,
                section_id: selectSection?.id,
                date: selectedDate || "",
                page: currentPage,
                limit,
                search,
              }
        )
          .then((response) => {
            setLoading(false);
            setTableData(response.data);
            setTotalData(response.total);
          })
          .catch((error) => {
            setLoading(false);
            toast.error(`Failed to fetch ${pageFor} data!`);
            console.error(`Error fetching ${pageFor} data: `, error);
          });


      }, 300); // Debounce time of 300ms
    },
    [selectedDate, currentPage, limit, search, selectClass, selectSection,pageFor]
  );


 

    // To track if it's the first render

  useEffect(() => {
    if (!pageFor) return;  // Exit if pageFor isn't defined
     
    if (!isFirstRender.current) {
      isFirstRender.current = true;  // Skip the first render
      return;
    }
  
    fetchData();  // Call fetchData on subsequent renders
  }, [search, currentPage, limit, selectClass, selectSection, pageFor]);
 

  useEffect(() => {
    if (selectClass && selectClass.id) {
      let sectionData = [];
      // Note: classes functionality removed as it's not available for HR management system
      const selectClassData = null;

      if (selectClassData) {
        sectionData = convertToLabelValue(selectClassData.sections);
      }

      setSectionDataList([...sectionData]);
    }
  }, [selectClass]);

  // Note: _fetchClasses dispatch removed as class functionality is not available for HR management system

  const callback = (error = false, response = null) => {
    if (error) {
      toast.error("File download failed!");
      return;
    }
    if (response) {
      // window.location.href = response;
      window.open(response, "_blank");
    } else {
      toast.error("File download failed!");
    }
  };

  const handleExportDownload = async () => {
    const type = location.pathname.includes("/staff") ? "staff" : "student";
    const fetchFunction =
      type === "staff" ? staffAttendanceReport : studentAttendanceReport;

    fetchFunction(
      type === "staff"
        ? {
            date: selectedDate || "",
            // page: currentPage,
            // limit,
            search,
            export:true
          }
        : {
            class_id: selectClass?.id,
            section_id: selectSection?.id,
            date: selectedDate || "",
            // page: currentPage,
            // limit,
            search,
            export:true

          }
    )
      .then((response) => {
        callback(false, response);
      })
      .catch((error) => {
        setLoading(false);
        toast.error(`Failed to fetch ${type} data!`);
        console.error(`Error fetching ${type} data: `, error);
      });
    //  if (response) {
    //      callback(false, response);
    //  }
  };

  return (
    <div className="flex flex-col shadow-md">
      <PageTableHeader
        breadcrumbs={items}
        isSearch={true}
        onSearchChange={handleSearchChange}
        isFilter={false}
        buttons={
          <div className="flex gap-2">
          <div className=" ">
            <DefaultButton
              icon={<FiFilter />}
              iconClass="text-md"
              variant="primary"
              onClick={toggleFilterVisibility}
            />
          </div>

          <div className=" ">
            <DefaultButton
            name={"Export"}
              icon={<PiExport />}
              iconClass="text-md"
              variant="primary"
              onClick={()=>{handleExportDownload()}}
            />
          </div>
          </div>
        }
      />

      <div className="flex flex-col">
        {isFilterVisible && (
          <div
            className="flex flex-row gap-2 px-4 py-2 text-theme font-bold
           items-center bg-white my-1"
          >
            <h2>Filters</h2>
            <label>Class</label>
            {pageType !== "staff" ? (
              <>
                <DefaultSearchSelectInput
                  id={"class_id"}
                  name={"class_id"}
                  // Note: classes removed as class functionality is not available
                  options={[]}
                  onChange={(e) => {
                    setSelectClass(e);
                  }}
                />
                <label>Section</label>
                <DefaultSearchSelectInput
                  id={"class_id"}
                  name={"class_id"}
                  options={sectionDataList}
                  onChange={(e) => {
                    setSelectSection(e);
                  }}
                />
              </>
            ) : (
              ""
            )}
 

            <YearMonthFilter handleChangeDate={handleChangeDate} />
          </div>
        )}

        <AttendanceReportTable
          setTotalData={setTotalData}
          loading={loading}
          search={search}
          data={tableData}
        />

        {/* Pagination component */}
        <PaginationComponent
          itemPerPage={limit}
          currentPage={currentPage}
          totalItems={totalData}
          paginate={setCurrentPage}
        />
      </div>
    </div>
  );
};

export default AttendanceReports;
